"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductPartsDataProvider = function () {
  function ProductPartsDataProvider(ProductPartsService, db) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ProductPartsDataProvider);
    this.ProductPartsService = ProductPartsService;
    this.colors = db.getCollection("colors");
    this.shapes = db.getCollection("shapes");
    this.fixmethods = db.getCollection("fix_methods");
    this.db = db;
  }

  (0, _createClass3.default)(ProductPartsDataProvider, [{
    key: "loadShapes",
    value: function loadShapes() {
      var _this = this;

      return this.ProductPartsService.loadAllShapes().then(function (shapes) {
        _this.shapes.insert(shapes);
        return shapes;
      });
    }
  }, {
    key: "loadFixmethods",
    value: function loadFixmethods() {
      var _this2 = this;

      return this.ProductPartsService.loadAllFixmethods().then(function (fixmethods) {
        _this2.fixmethods.insert(fixmethods);
        return fixmethods;
      });
    }
  }, {
    key: "loadColors",
    value: function loadColors() {
      var _this3 = this;

      return this.ProductPartsService.loadAllColors().then(function (colors) {
        _this3.colors.insert(colors);
        return colors;
      });
    }
  }]);
  return ProductPartsDataProvider;
}();

// WEBPACK FOOTER //


exports.default = ProductPartsDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-parts/parts.dataprovider.service.js
 **/